import { ReactNode } from 'react';
import {
  useGetLineDisplayOrderQuery,
  useCreateMachineDisplayOrderMutation,
  useUpdateMachineDisplayOrderMutation
} from 'api';

interface Props {
  lineId: string;
}

export const useMachinesInTheLineWidget = ({lineId}: Props): {
  isLoading?: boolean;
  hasError?: ReactNode;
  hasMessage?: ReactNode;
  [key: string]: unknown;
} => {

  const { data: dataLineOrder, isFetching: dataLineOrderIsFetching } = useGetLineDisplayOrderQuery({
    lineId
  });

  return {
    dataLineOrder, dataLineOrderIsFetching
  };
};

export const useMachineOrder = () => {
  const [createMachineDisplayOrder] = useCreateMachineDisplayOrderMutation();
  const [updateMachineDisplayOrder] = useUpdateMachineDisplayOrderMutation();

  const createMachineDisplayOrderFunc = async (line_id?: string, machine_id?: string, display_order?: string) => {
    await createMachineDisplayOrder({
      configuration: {
        machine_id: machine_id,
        line_id: line_id,
        display_order: display_order
      }
    }).unwrap().catch((error) => {
      console.error(error?.data?.detail);
    });
  };

  const updateMachineDisplayOrderFunc = async (machine_id?: string, display_order?: string) => {
    await updateMachineDisplayOrder({
      configuration: {
        machine_id: machine_id,
        display_order: display_order
      }
    })
    .unwrap()
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error(error?.data?.detail);
      throw new Error(error);
    });
  };

  return {
    createMachineDisplayOrderFunc,
    updateMachineDisplayOrderFunc
  };
};
